import { createPortal } from "react-dom";

// Ж21 (TZ-7 п.4): модалки рендерятся в document.body — иначе transform предка (.reversia-card:hover)
// становится containing block для position:fixed, оверлей сжимается до карточки и мерцает циклом hover
export const ModalPortal = ({ children }) => createPortal(children, document.body);
